import { NgModule } from '@angular/core';
import { ColorPickerComponent } from './color-picker.component';

@NgModule({
  imports: [ColorPickerComponent],
  exports: [ColorPickerComponent],
})
export class ColorPickerModule {}
